<router-outlet></router-outlet>
<div class="loading-buttons" style="display: none; cursor: not-allowed !important; pointer-events: all !important;"
    id="loader-div">
    <span class="loading-icon">
        <img src="assets/images/loader/spinner.gif" />
    </span>
</div>